import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function OurServices() {
  const services = [{
    num: '1',
    name: 'Commercial Cleaning',
    path: '/commercial-cleaning'
  }, {
    num: '2',
    name: 'Basic Home Cleaning',
    path: '/basic-home-cleaning'
  }, {
    num: '3',
    name: 'Spring/Deep Cleaning',
    path: '/spring-deep-cleaning'
  }, {
    num: '4',
    name: 'Move-In/Move-Out',
    path: '/move-in-move-out-quote'
  }, {
    num: '5',
    name: 'Post Renovation',
    path: '/post-renovation-quote'
  }, {
    num: '6',
    name: 'Airbnb/Short Term Rental',
    path: '/airbnb-quote'
  }];
  return <section className="w-full relative overflow-hidden" data-id="element-409">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-410">
        <img src="https://cdn.magicpatterns.com/uploads/qvCeQwTAdJwGp7cTDszDSa/sj-website-home-img1.png" alt="Modern interior showcasing professional cleaning services" className="w-full h-full object-cover" loading="lazy" decoding="async" width={1920} height={1080} data-id="element-411" />
      </div>

      {/* Content overlay */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 min-h-[700px] flex flex-col justify-between" data-id="element-412">
        {/* Services List - Top Right Area */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-full lg:w-3/5 lg:ml-auto" data-id="element-413">
          <div className="space-y-0" data-id="element-414">
            {services.map((service, idx) => <motion.div key={service.num} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: idx * 0.1
          }} data-id="element-415">
                <Link to={service.path} className="flex items-center gap-6 py-4 border-b border-gray-400/40 group cursor-pointer" data-id="element-416">
                  <span className="font-bebas text-lg text-[#1a2744]/60 w-6 flex-shrink-0" data-id="element-417">
                    {service.num}
                  </span>
                  <div className="w-px h-5 bg-[#1a2744]/30 flex-shrink-0" data-id="element-418" />
                  <span className="text-base md:text-lg font-medium text-[#1a2744] group-hover:text-[#e91e8c] transition-colors flex-1" data-id="element-419">
                    {service.name}
                  </span>
                  <ArrowRightIcon className="w-5 h-5 text-[#1a2744]/50 group-hover:text-[#1a2744] transition-colors flex-shrink-0" data-id="element-420" />
                </Link>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Bottom Section: OUR SERVICES title */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="flex items-end justify-between mt-12 lg:mt-0" data-id="element-421">
          <div className="flex-1" data-id="element-422" />
          <div className="flex items-end gap-6" data-id="element-423">
            <h2 className="text-[4rem] md:text-[7rem] lg:text-[9rem] font-bebas text-[#1a2744] leading-[0.85] tracking-wide text-right" data-id="element-424">
              OUR
              <br data-id="element-425" />
              SERVICES
            </h2>
            <div className="mb-4 md:mb-8 w-12 h-12 rounded-full border-2 border-[#1a2744] flex items-center justify-center flex-shrink-0 cursor-pointer hover:bg-[#1a2744] hover:text-white transition-colors group" data-id="element-426">
              <ArrowRightIcon className="w-5 h-5 text-[#1a2744] group-hover:text-white transition-colors" data-id="element-427" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}